<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 7695 7695"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <g id="_723620032">
   <path class="fil0" d="M6659 0l-5597 0c-579,0 -1062,447 -1062,1025l0 5597c0,579 483,1073 1062,1073l115 0 6 0 3116 0 -816 -2315c-303,-862 191,-1820 1104,-2141 912,-322 1903,116 2206,977l902 2547 0 -3812 0 -3 0 -1923c0,-578 -458,-1025 -1036,-1025z"/>
   <path class="fil0" d="M4205 3991c-561,565 -557,1479 9,2040 566,561 1479,558 2040,-8 563,-566 559,-1479 -7,-2041 -566,-562 -1480,-558 -2042,9z"/>
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'Mode',
};
</script>

<style scoped>
.fil0 {fill:#56D6D1;fill-rule:nonzero}
</style>
